import styled from 'styled-components';

const CreateUserBtn = styled.div`
    font-size:16px;
    background:#319795;
    border:1px solid #319795;
    height:40px;
    width:20%;
    display:flex;
    align-items:center;
    justify-content:center;
    color:white;
    cursor:pointer;
    border-radius:0px 8px 8px 0px;
    text-align:center;
`

export default CreateUserBtn;
